import {supabase} from '../supabase/client.js';

export const CARD_FREE_TRIAL_SOURCE = 'card_free_trial';

function functionStatus(error) {
  const status = Number(error?.context?.status);
  return Number.isInteger(status) ? status : null;
}

async function isDisabledActivation(error) {
  if (functionStatus(error) !== 503 || typeof error?.context?.json !== 'function') return false;
  try {
    const response = typeof error.context.clone === 'function' ? error.context.clone() : error.context;
    const payload = await response.json();
    return payload?.error === 'Card-free trial activation is not available.';
  } catch {
    return false;
  }
}

export async function activateCardFreeTrial(values, client = supabase) {
  if (!client) throw new Error('Supabase is not configured.');

  const {data, error} = await client.functions.invoke('activate-card-free-trial', {
    body: {
      activation_key: values.activationKey,
      business_name: values.businessName,
      description: values.description || '',
      legal_structure: values.legalStructure,
      country: values.country,
      province: values.province || null
    }
  });

  if (error) {
    if (await isDisabledActivation(error)) return {available: false};
    throw new Error('The card-free trial could not be activated. Please try again.');
  }

  if (!data?.business_id || !data?.trial_started_at || !data?.trial_ends_at) {
    throw new Error('The card-free trial returned an incomplete response.');
  }

  return {available: true, ...data};
}

export async function getCardFreeTrialStatus(businessId, client = supabase) {
  if (!client) throw new Error('Supabase is not configured.');
  if (!businessId) return null;

  const {data, error} = await client.rpc('get_card_free_trial_status', {
    p_business_id: businessId
  });

  if (error) throw error;
  const status = Array.isArray(data) ? data[0] : data;
  return status?.entitlement_source === CARD_FREE_TRIAL_SOURCE ? status : null;
}

export function cardFreeTrialRemaining(status) {
  if (status?.entitlement_source !== CARD_FREE_TRIAL_SOURCE || status.access_state !== 'trialing') {
    return null;
  }

  const now = new Date(status.server_now);
  const end = new Date(status.trial_ends_at);
  if (Number.isNaN(now.getTime()) || Number.isNaN(end.getTime())) return null;

  const milliseconds = Math.max(0, end.getTime() - now.getTime());
  return {milliseconds, days: Math.ceil(milliseconds / 86400000)};
}

export function cardFreeTrialRemainingLabel(status) {
  const remaining = cardFreeTrialRemaining(status);
  if (!remaining) return '';
  if (remaining.milliseconds === 0) return 'Trial ends now';
  if (remaining.milliseconds < 86400000) return 'Less than one day remains';
  return `${remaining.days} day${remaining.days === 1 ? '' : 's'} remaining`;
}
